import { PricingService } from '../services/pricing.service';
import { RecommendationService } from '../services/recommendation.service';
import { Component, OnInit } from '@angular/core';
import { AnalysisService } from 'app/services/analysis.service';
import { InstallationcostService } from 'app/services/installationcost.service';
import { isHK } from 'app/app.component';

@Component({
  selector: 'app-costs',
  templateUrl: './costs.component.html',
  styleUrls: ['./costs.component.css']
})
export class CostsComponent implements OnInit {

  disabled = false;
  min = 89;
  max = 2000;
  thumbLabel = true;
  currentCost: number;
  energyPrice: number;

  constructor(
    private installationcostService: InstallationcostService,
    private pricingService: PricingService,
    private analysisService: AnalysisService,
    private recommendationService: RecommendationService) { }

  ngOnInit() {
    this.currentCost = this.pricingService.getMonthlyCost();
    this.energyPrice = this.pricingService.getkWhPrice_PLN();
  }

  getIsHK(): boolean {
    return isHK;
  }

  onChange() {
    this.energyPrice = Math.round(100 * this.energyPrice) / 100;
    this.pricingService.setkWhPrice(this.energyPrice);
    this.pricingService.setMonthlyCosts_PLN(this.currentCost);
    this.recommendationService.updReccomendations();
    this.installationcostService.updateCosts();
  }

  showPricing(): boolean {
    return this.analysisService.getRoofArea() > 0;
  }

  getRequisitionD() {
    return this.pricingService.getMonthlyPowerRequisition_kWh() / 30;
  }

  getRequisitionM() {
    return this.pricingService.getMonthlyPowerRequisition_kWh();
  }

  getRequisitionY() {
    return this.pricingService.getMonthlyPowerRequisition_kWh() * 12;
  }

  getYearlyCost() {
    return this.pricingService.getYearlyCost();
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/costs/costs.component.ts